import { enumTradeAggregateType } from '@rematter/frontend-lib-api-client';
import { Col, Row, Loading, cn } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';
import {
  LucideBox,
  LucideClipboardList,
  LucideFileText,
  LucideTruck,
} from 'lucide-react';

import {
  $remoteTradeOutboxEventCounts,
  useTradeAggregateTypeFilter,
} from '@/audit-log/_state/tradeEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';

const aggregateTypeConfig = [
  {
    type: enumTradeAggregateType.Booking,
    labelKey: 'booking' as const,
    icon: LucideBox,
    countKey: 'booking' as const,
  },
  {
    type: enumTradeAggregateType.Load,
    labelKey: 'load' as const,
    icon: LucideTruck,
    countKey: 'load' as const,
  },
  {
    type: enumTradeAggregateType.SalesOrder,
    labelKey: 'salesOrder' as const,
    icon: LucideClipboardList,
    countKey: 'salesOrder' as const,
  },
  {
    type: enumTradeAggregateType.PurchaseOrder,
    labelKey: 'purchaseOrder' as const,
    icon: LucideFileText,
    countKey: 'purchaseOrder' as const,
  },
];

export const TradeEventsSidebar = () => {
  const t = useTranslations();
  const [selectedType, setSelectedType] = useTradeAggregateTypeFilter();
  const { data: counts, isLoading } = useAtomValue(
    $remoteTradeOutboxEventCounts,
  );

  const totalCount = counts
    ? counts.booking + counts.load + counts.salesOrder + counts.purchaseOrder
    : 0;

  return (
    <Col className="@TradeEventsSidebar w-[200px] border-r border-neutral/10 p-3">
      <Loading isLoading={isLoading}>
        <Col gap2>
          <button
            onClick={() => setSelectedType(undefined)}
            className={cn(
              'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
              selectedType === undefined
                ? 'bg-primary/10 text-primary'
                : 'hover:bg-neutral/5',
            )}
          >
            <span>{t.tradeEventsView.sidebar.all}</span>
            <span className="text-xs text-neutral/50">{totalCount}</span>
          </button>

          {aggregateTypeConfig.map(
            ({ type, labelKey, icon: Icon, countKey }) => (
              <button
                key={type}
                onClick={() => setSelectedType(type)}
                className={cn(
                  'flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors',
                  selectedType === type
                    ? 'bg-primary/10 text-primary'
                    : 'hover:bg-neutral/5',
                )}
              >
                <Row gap2 yCenter>
                  <Icon size={16} className="text-neutral/60" />
                  <span>
                    {t.tradeEventsView.sidebar.aggregateTypes[labelKey]}
                  </span>
                </Row>
                <span className="text-xs text-neutral/50">
                  {counts?.[countKey] ?? 0}
                </span>
              </button>
            ),
          )}
        </Col>
      </Loading>
    </Col>
  );
};
